import { render, staticRenderFns } from "./collapse.vue?vue&type=template&id=06531722&"
import script from "./collapse.vue?vue&type=script&lang=js&"
export * from "./collapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06531722')) {
      api.createRecord('06531722', component.options)
    } else {
      api.reload('06531722', component.options)
    }
    module.hot.accept("./collapse.vue?vue&type=template&id=06531722&", function () {
      api.rerender('06531722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/collapse/collapse.vue"
export default component.exports